var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBdLikeIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30.371,
    height: 29.203,
    viewBox: "0 0 30.371 29.203",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-ios-heart-empty",
    "data-name": "Icon ionic-ios-heart-empty",
    d: "M25.569,3.938H25.5a8.307,8.307,0,0,0-6.936,3.8,8.307,8.307,0,0,0-6.936-3.8h-.073a8.254,8.254,0,0,0-8.177,8.25,17.771,17.771,0,0,0,3.49,9.688c4.4,6.009,11.7,11.265,11.7,11.265s7.3-5.257,11.7-11.265a17.772,17.772,0,0,0,3.49-9.688A8.254,8.254,0,0,0,25.569,3.938Zm3.037,16.733a56,56,0,0,1-10.046,9.9A56.08,56.08,0,0,1,8.515,20.664a15.75,15.75,0,0,1-3.1-8.476,6.194,6.194,0,0,1,6.147-6.2h.066a6.121,6.121,0,0,1,3,.788,6.379,6.379,0,0,1,2.219,2.081,2.051,2.051,0,0,0,3.431,0A6.443,6.443,0,0,1,22.5,6.778a6.121,6.121,0,0,1,3-.788h.066a6.194,6.194,0,0,1,6.147,6.2A15.95,15.95,0,0,1,28.607,20.671Z",
    transform: "translate(-3.375 -3.938)",
    fill: "#40eefe"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBdLikeIcon);
export default __webpack_public_path__ + "static/media/bd-like-icon.b16b5f008076cb783708d46950585432.svg";
export { ForwardRef as ReactComponent };